import React, { PureComponent } from 'react';
import { get, noop } from 'lodash';
import PropTypes from 'prop-types';
import { filterToValidAttributes } from '@zocdoc/dom-property';
import styled, { ThemeProvider } from 'styled-components';
import Arrow from '../icons/Arrow';
import { FontFamily } from '../typography';

const THEME_PATH = 'theme.components.CollapsibleSection';

export class CollapsibleSectionView extends PureComponent {
    static propTypes = {
        headerOpenText: PropTypes.string,
        headerText: PropTypes.string,
        isOpen: PropTypes.bool,
        onCollapseClick: PropTypes.func,
    };

    static defaultProps = {
        headerOpenText: '',
        headerText: '',
        isOpen: false,
        onCollapseClick: noop,
    };

    render() {
        return (
            <ThemeProvider theme={{ expanded: this.props.isOpen }}>
                <Container {...filterToValidAttributes(this.props)}>
                    {this.renderHeader({ arrowDirection: this.props.isOpen ? 'up' : 'down' })}
                    {this.maybeRenderChildren()}
                </Container>
            </ThemeProvider>
        );
    }

    maybeRenderChildren() {
        if (this.props.isOpen) {
            return (
                <Children
                    data-test="children-section"
                    innerRef={this.maybeScrollToChildren}
                >
                    {this.props.children}
                </Children>
            );
        }
    }

    renderHeader({ arrowDirection }) {
        const {
            headerText,
            headerOpenText,
            isOpen,
            onCollapseClick,
        } = this.props;

        return (
            <Header
                data-test="header-section"
                onClick={onCollapseClick}
            >
                {isOpen ? headerOpenText || headerText : headerText}

                <StyledArrow
                    color="currentColor"
                    direction={arrowDirection}
                    height={get(this.props, `${THEME_PATH}.header.arrowSize`)}
                />
            </Header>
        );
    }

    maybeScrollToChildren = el => {
        if (this.props.autoScroll && el && el.scrollIntoView) {
            el.scrollIntoView();
        }
    };
}

const theme = props => props.theme.components.CollapsibleSection;

const Container = styled.div`
    background-color: ${p => theme(p).children.bgColor};
    color: ${p => theme(p).children.textColor};
`;

const Header = styled.div`
    align-items: center;
    background-color: ${p => theme(p).header[p.theme.expanded ? 'bgColorExpanded' : 'bgColor']};
    box-sizing: border-box;
    color: ${p => theme(p).header[p.theme.expanded ? 'textColorExpanded' : 'textColor']};
    cursor: pointer;
    display: flex;
    font: ${p => theme(p).header.fontSize}px ${FontFamily.SharpSansBold};
    padding: 16px 28px;
    position: relative;
    height: ${p => theme(p).header.height}px;
`;

const StyledArrow = styled(Arrow)`
    cursor: pointer;
    margin-left: auto;
`;

const Children = styled.div`
    padding: 12px 28px;
    position: relative;

    &::before {
        background-color: ${p => theme(p).children.borderColor};
        content: '';
        position: absolute;
        top: 0;
        left: 10px;
        right: 10px;
        height: 2px;
    }
`;

export const primitives = {
    Header,
    StyledArrow,
    Children,
};
